/**
 * @file: brand.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { rpxHub } from '@euler/app/tv/functions/utils';
import { VehicleBrandInfo } from '@euler/model/vehicle';
import { serviceFactory } from '@euler/services/factory';
import { Observable } from 'rxjs';
import { AbstractSearchCriterionProvider } from '../AbstractSearchCriterionProvider';
import { SearchCriterionOption } from '../types';

export class VehicleBrandCriterion extends AbstractSearchCriterionProvider<'vehicleBrand'> {
  static readonly shared = new VehicleBrandCriterion();

  private _brands: VehicleBrandInfo[] | undefined;

  constructor() {
    super('vehicleBrand');
  }

  getLabel(): string {
    return '车辆品牌';
  }

  getDisplayImage(value: VehicleBrandInfo | undefined): string | undefined {
    return value?.logo;
  }

  internalGetDisplayText(value: VehicleBrandInfo): string {
    return value.name;
  }

  internalGetOptions(): SearchCriterionOption<VehicleBrandInfo>[] {
    throw new Error('Method not implemented.');
  }

  getOptions(): Observable<SearchCriterionOption<VehicleBrandInfo>[]> {
    return new Observable(subscriber => {
      if (this._brands != null) {
        // return the cached results directly.
        subscriber.next(this.makeOptions(this._brands));
        subscriber.complete();
        return;
      }

      // try to get the recent list of order tags.
      serviceFactory.vehicleInfoService
        .getVehicleBrands()
        .then(brands => {
          this._brands = brands;
          subscriber.next(this.makeOptions(brands));
          subscriber.complete();
        })
        .catch(err => {
          console.error(err);
          subscriber.next([]);
          subscriber.complete();
        });
    });
  }

  protected internalGetKey(value: VehicleBrandInfo): string {
    return value.name;
  }

  private makeOptions(
    brands: VehicleBrandInfo[],
  ): SearchCriterionOption<VehicleBrandInfo>[] {
    return [
      { value: undefined },
      ...brands.map<SearchCriterionOption<VehicleBrandInfo>>(brand => ({
        value: brand,
        text: brand.name,
        image: brand.logo,
        showImage: true,
        imageStyle: { width: rpxHub(40), height: rpxHub(40) },
      })),
    ];
  }
}
